import { render, staticRenderFns } from "./PPuser.vue?vue&type=template&id=018e857d&scoped=true&"
import script from "./PPuser.vue?vue&type=script&lang=js&"
export * from "./PPuser.vue?vue&type=script&lang=js&"
import style0 from "./PPuser.vue?vue&type=style&index=0&id=018e857d&lang=scss&scoped=true&"
import style1 from "./PPuser.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018e857d",
  null
  
)

export default component.exports